import { ExpandControlledConfigProps } from '@/types';
import { ControlledInput, Loading } from '@amili-v3/amili-v3-design';
import { InfiniteData, UseInfiniteQueryResult } from '@tanstack/react-query';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
import React, { forwardRef, memo } from 'react';
import { ControlledInputConfig } from '../customByConfiguration';
import { SelectProps } from 'antd';

type KeysInQuery = 'isFetching' | 'isLoading' | 'hasNextPage' | 'fetchNextPage';
export type InfinityProps = ExpandControlledConfigProps & {
  infinityQueryResult: Pick<
    UseInfiniteQueryResult<InfiniteData<any, any>, Error>,
    KeysInQuery
  >;
  filterValue: string;
  setFilterValue?: React.Dispatch<React.SetStateAction<string>>;
  isControlledConfig?: false;
};

/**
 * Explain some field props in this base:
 * 1. @param isPreventCustomConfig: auto true - Do not allow to use custom config KEY for each option
 * 2. @param isControlledConfig: auto true - Allow user use Controlled Input have OR not have custom config key
 */

const InfinityScrollControlled = forwardRef<HTMLDivElement, InfinityProps>(
  (props, ref) => {
    const {
      infinityQueryResult,
      isControlledConfig = true,
      loading: customLoading,
      filterValue,
      setFilterValue = () => {},
      filterOption = false,
      onPopupScroll,
      mode,
      ...rest
    } = props;
    const { isLoading, isFetching, hasNextPage, fetchNextPage } =
      infinityQueryResult;
    const loading = customLoading ?? (isLoading || isFetching);
    // const queryClient = useQueryClient();

    // const [selectedItem, setSelectedItem] = useState<CustomOptionType>();
    // const mergeOptions = useMemo(() => {
    //   const exists = options.some(opt => opt.value === selectedItem?.value);
    //   if (!exists && selectedItem) {
    //     return [{ ...selectedItem }, ...options];
    //   }
    //   return options;
    // }, [options, selectedItem]);

    const handleClear = () => setFilterValue('');

    const searchDebounce = debounce((inputValue: string) => {
      // Clear previous search, prevent query many pages on time
      // queryClient.removeQueries({ queryKey, exact: true });
      setFilterValue(inputValue);
    }, 300);

    const onScroll = throttle((event: React.UIEvent<HTMLDivElement>) => {
      const target = event.target as HTMLDivElement;

      if (
        !isFetching &&
        target.scrollTop + target.offsetHeight >= target.scrollHeight - 100 &&
        hasNextPage &&
        fetchNextPage
      ) {
        fetchNextPage();
      }
    }, 200);

    const dropdownRender: SelectProps['dropdownRender'] = menu => {
      return (
        <div>
          {menu}
          {loading && (
            <div style={{ padding: 10 }}>
              <Loading size="small" />
            </div>
          )}
        </div>
      );
    };

    const Controlled = isControlledConfig
      ? ControlledInputConfig
      : ControlledInput;

    return (
      <Controlled
        {...rest}
        ref={(ref as any) || props.ref}
        inputType="select"
        isPreventCustomConfig
        // filterOption={(inputValue: string, option?: DefaultOptionType) => {
        //   searchDebounce(inputValue);
        //   return filterOptionFunc(inputValue, option);
        // }}
        filterOption={filterOption}
        // options={mergeOptions as ControlledInputProps['options']}
        mode={mode}
        onPopupScroll={onPopupScroll ?? onScroll}
        loading={customLoading}
        onSearch={value => searchDebounce(value)}
        onClear={handleClear}
        // onBlur={mode ? handleClear : undefined}
        // onChange={value => {
        //   const findOpt = options.find(opt => opt.value === value);
        //   setSelectedItem(findOpt);
        // }}
        dropdownRender={dropdownRender}
      />
    );
  },
);

InfinityScrollControlled.displayName = 'InfinityScrollControlled';
export default memo(InfinityScrollControlled);
